export class ListOrganizationUsersResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "users",
            "baseName": "users",
            "type": "Array<OrganizationUser>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListOrganizationUsersResponse.attributeTypeMap;
    }
    constructor() {
    }
}
